export default function useScrollToElement() {
  return (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const scrollOffset = element.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
    }
  };
}
